import {createSelector} from 'reselect';

import type {NutshellState} from '../../store';

import {getUIState} from '../ui-selectors';

const getEmailComposerState = createSelector([getUIState], (uiState) => uiState.emailReply);

export const getIsOpen = (state: NutshellState) => {
    return getEmailComposerState(state).isOpen;
};

export const getReplyToEmailId = (state: NutshellState) => {
    return getEmailComposerState(state).replyToEmailId;
};

export const getIsReplyingAll = (state: NutshellState) => {
    return getEmailComposerState(state).isReplyingAll;
};

export const getOnReplySuccess = (state: NutshellState) => {
    return getEmailComposerState(state).onReplySuccess;
};

export const getSuggestedEmailReplyId = (state: NutshellState) => {
    return getEmailComposerState(state).suggestedEmailReplyId;
};

export const getIsReplyMinimized = (state: NutshellState) => {
    return getEmailComposerState(state).isMinimized;
};

export const getPendingRestoreReplyFromMinimize = (state: NutshellState) => {
    return getEmailComposerState(state).pendingRestoreFromMinimize;
};
